.pill {
  display: inline-flex;
  align-items: center;
  gap: var(--tuna-spacing-1);
  height: 36px;
  padding: 0 var(--tuna-spacing-1_5) 0 var(--tuna-spacing-0_5);
  border: 1px solid var(--tuna-palette-divider);
  border-radius: var(--tuna-shape-radius-pill);
  background-color: var(--tuna-surface-default);
  color: var(--tuna-palette-text-primary);
  cursor: pointer;
  flex-shrink: 0;
}

.pill:hover {
  background-color: var(--tuna-palette-action-hover);
}

.pill:focus-visible {
  outline: 2px solid var(--tuna-palette-primary-main);
  outline-offset: 2px;
}

.stack {
  display: inline-flex;
  border-radius: var(--tuna-shape-radius-pill);
}

/* Any agent mid-turn: a ring around the stack (the per-agent status is spoken in the menu) */
.stack--thinking {
  outline: 2px dashed var(--tuna-palette-primary-main);
  outline-offset: 1px;
}

.initials {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: var(--tuna-shape-radius-circle);
  color: var(--tuna-content-onColor);
  font-size: var(--tuna-typography-fontSize-xs);
  font-weight: 600;
  flex-shrink: 0;
}

.stacked {
  border: 2px solid var(--tuna-surface-default);
}

.stacked + .stacked {
  margin-left: -8px;
}

.label {
  font-size: var(--tuna-typography-fontSize-sm);
}

.badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: var(--tuna-shape-radius-pill);
  background-color: var(--tuna-palette-primary-main);
  color: var(--tuna-palette-primary-contrastText);
  font-size: var(--tuna-typography-fontSize-xs);
  font-weight: 600;
}

.itemName {
  margin-left: var(--tuna-spacing-1);
}

.itemStatus {
  margin-left: auto;
  padding-left: var(--tuna-spacing-2);
  color: var(--tuna-palette-text-secondary);
  font-size: var(--tuna-typography-fontSize-xs);
}

@media (max-width: 599.95px) {
  .label {
    display: none;
  }
}
